module.exports = __webpack_public_path__ + "img/fourth_door_on.1f17640f.png";